import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@fortawesome/fontawesome-free/css/all.css'
import VueAnalytics from 'vue-analytics'
import VueLodash from 'vue-lodash';
import VueI18n from 'vue-i18n';
import webtor from '@webtor/platform-sdk-js';
import VueGlobalVar from "vue-global-var";

const options = { name: 'lodash' };
Vue.config.productionTip = false;

Vue.use(VueI18n);
Vue.use(VueLodash, options);

if(location.host!=='localhost:8080'){
  Vue.use(VueAnalytics, {
    id: 'UA-154142701-1',
    router
  });
}

Vue.use(VueGlobalVar, {
  globals: {
    videoSDK: webtor({
      apiUrl: 'https://api.webtor.io',
      apiKey: '',
      getToken: function(){
        let self = this;
        async function getToken(){
          const res = await fetch('//api.maikaelev.com/token');
          let data = await res.json()
          self.apiKey = data.apiKey;
          self.token = data.token;
          return data.token;
        }
        async function getSelfToken(){
          if(window.torrentApiData){
            self.apiKey = window.torrentApiData.apiKey;
            return window.torrentApiData.token;
          }
          return self.token;
        }
        return this.token || window.torrentApiData ? getSelfToken():getToken();
      }

    }),
    useCluster: true,
    statClient: {test:true}
  }
});

new Vue({
  router,
  store,
  vuetify,
  iconfont: 'fa',
  render: h => h(App)
}).$mount('#app');


